//Object.create polyfill
if (typeof Object.create !== 'function') {
    Object.create = function(obj) {
        function F(){}
        F.prototype = obj;
        return new F();
    };
}

(function($) {
	var errorMessageStore = ErrorMessageStore;
	
	var DatabaseConfig = {
		// Local data
		dbExists: false,
		myValidator: null,
		
		init: function(options, element) {
            //store a reference to the element
            this.element = element;
            //store a reference to the jquery element object
            this.$element = $(element);
            //override our options with the options passed in
            this.options = $.extend({}, $.fn.databaseConfig.options, options);

            this.initControls();
            this.showControls();
            this.setupValidators();

            $('#dbSelect').val(this.options.dbSelect);
            
            // Event handlers
            $('#dbmsType').change($.proxy(this.typeChanged, this));
            $('#reset').click($.proxy(this.reset, this));
            $('#SaveDDLScripts').click($.proxy(this.saveDDLScripts, this));
            $('#apply').click($.proxy(this.testAndApply, this));
            $('#db2Security').change($.proxy(this.securityChanged, this));
            $('#dbSelect').change($.proxy(this.dbSelectClicked, this));
		},

		// Update database data with new data after a change is
		// successfully posted so our internal data matches reality
		updateData: function(newData) {
			this.options.dbParameters = newData;
			this.initControls();
		},
		
		// Set up the data validators
		setupValidators: function() {
			$.validator.addMethod("dbName", function(value, element){
				var type = $('#dbmsType').val();
				
				if (type === sqlserver) {
					return (/^[_A-Za-z0-9]*$/.test(value));
				} else if (type === db2luw) {
					return (/^[A-Za-z][A-Za-z0-9\ \\\!\%\(\)\.\-\^\_\@\#\$]{0,7}$/.test(value));
				} else if (type === db2zos) {
					return (/^[A-Za-z][A-Za-z0-9\ \\\!\%\(\)\.\-\^\_\@\#\$]{0,7}$/.test(value));
				} else if (type === oracle) {
					return (/^[_A-Za-z][_A-Za-z0-9\.]*$/.test(value));
				}
			}, badDBname );
			
			$.validator.addMethod("schemaName", function(value, element){
				var type = $('#dbmsType').val();
				
				if (type === sqlserver) {
					return (/^[a-zA-Z_@#][\w@#$]{0,127}$/.test(value));
				} else if (type === db2luw) {
					return (/^[a-zA-Z0-9@#$][a-zA-Z0-9@#$_]{0,127}$/.test(value));
				} else if (type === db2zos) {					
					return (/^[a-zA-Z@#$][a-zA-Z0-9@#$]{0,7}$/.test(value));
				} else if (type === oracle) {
					return value.length >= 1 && value.length <= 30;
				}
			}, badSchemaname );
			
			$.validator.addMethod("instance", function(value, element) {
				if (value.length > 0) {
					return (/^[a-zA-Z_@#][\w@#$]{0,15}$/.test(value));
				} else {
					return true;
				}
			}, badInstancename);
			
			$.validator.addMethod("validateHostname", function(value, element) {
				return (value.search(/[^A-Za-z0-9-.]/) == -1);
			}, invalidHostnameMessage);
			
			$.validator.addMethod("portOrInstance", function(instancevalue, element) {
				var portValue = $('#dbmsPort').val();
				
				if (instancevalue.length == 0 && portValue.length == 0) {
					return false;
				} else if(instancevalue.length > 0 && portValue.length > 0)	{
					return false;				
				} else {
					return true;
				}
			}, portOrInstanceMessage);
			
			$.validator.addMethod("tablespace", function(value, element) {
				return (/^[a-zA-Z][a-zA-Z0-9_]{0,7}$/.test(value));
			}, badTablespace);
			
			// if the password is under 9 chars, no validation (just like before) otherwise, we validate for passphrase
			// if incoming element is the db admin password, only validate if the db admin user is not null
			$.validator.addMethod("passPhrase", function(value, element) {
			    var securityValue = $('#db2Security').val();
			    
				if ($('#dbmsType').val() != db2zos){
					return ((/^\S{1,}$/.test(value)) 
							|| (element.id === 'dbAdminPassword' && $('#dbAdminUserId').val() === ''));
				} else {
					return ((/^\S{1,8}$|(?!^[^'].*'$)(?!^'.*[^']$)(?!^\s{1,}.*)(?!.*\s{1,}$)(?!.*(.)\1\1)(?=.*[\d[:punct:].*[\d:punct:])(?=.*[a-zA-Z].*[a-zA-Z])^.{9,100}$/.test(value)) 
							|| (element.id === 'password' && securityValue === 'idonly')
							|| (element.id === 'dbAdminPassword' && $('#dbAdminUserId').val() === ''));
				}
			}, invalidPasswordPassphrase);

			var $self = this;

			this.myValidator = $('#dbConfigForm').validate({
				rules: {
					databaseHost: {
						required: true,
						validateHostname: true
					},
					
					databasePort: {						
						required: {
							depends: function(element) {
								return ($('#dbmsType').val() === db2zos || $('#dbmsType').val() === db2luw || $('#dbmsType').val() === oracle);
							}
						},
						digits : true,
						min : 1,
						max : 65535
					},
					
					databaseName: {
						required: true,
						dbName: true
					},
					
					jdbcDdlUsername: {
					    required: {
					        depends: function(element) {
                                var securityValue = $('#db2Security').val();
                                
                                return !(securityValue === 'passTicket_Custom');
					        }
					    }
					},
					
					jdbcDdlPassword: {
						required: {
							depends: function(element) {
								var securityValue = $('#db2Security').val();

								return !(securityValue === 'idonly' || securityValue === 'passTicket_Custom');
							}
						},
						passPhrase: true
					},
					
					// only invalid if db admin user is not null
					adminPassword: {
						passPhrase: true
					},

					
					db2SQLID: {
					    required: false
					},

					instanceName: {
						required: false,
						instance: true,
						portOrInstance: true
					},
					
					databaseSchema: {
						required: false,
						schemaName: true
					},
					
					databaseLocation: {
						required: {
							depends: function(element) {
								return $('#dbmsType').val() === db2zos;
							}
						}
					},
					
					databaseTablespace: {
						required: {
							depends: function(element) {
								return $('#dbmsType').val() === db2zos;
							}
						},
						tablespace: true
					},
					
					jdbcDriverPath: {
						required: {
							depends: function(element) {
								return ($('#dbmsType').val() === db2zos || $('#dbmsType').val() === db2luw)
							}
						}
					},					
                   passticketClass: {
						required: {
							depends: function(element) {
								return ( !uss )
							}
						}
					},
					passticketBundle: {
						required: {
							depends: function(element) {
								return ( !uss )
							}
						}
					},
				},
		        errorPlacement: function (error, element) {
		            $(element).removeClass("valid");
		            $(element).addClass("errorborder");
		            var message = error.html();
		            errorMessageStore.set(element[0].id, message);
		            
		            if (message && message.length > 0) {
		                $self.options.showError(message);
		            }
		        	
		        },
		        success : function(success, element) {
		            $(element).removeClass('error');
		            $(element).removeClass('errorborder');
		            errorMessageStore.remove(element.id);
		            
		            if ($self.myValidator.numberOfInvalids() === 0) {
		                $self.options.clearStatus();
		            }
		        },
		        onfocusin : function(element, event) {
	                $self.myValidator.element(element);
		        },
		        onfocusout : function(element, event) {
		        	$('#statusSection').slideUp();
		        },
		        onkeyup : function(element, event) {
		        	if (event.which !== 9) {
		        		$self.myValidator.element(element);
		        	}
		        }
			});
		},

		// User changed database selection
		dbSelectClicked: function() {
			var $self = this;
			
			// Get new data
	    	$.getJSON('database/list', 
    			{
    				requestType: 'list',
    				dbSelect: $('#dbSelect').val(),
    				nocache: new Date().getTime()
    			},
    			function(data) {
    				$self.options.dbParameters = data;
                    var derbyOptionField = $('#derbyOption');
    				
    				if ($('#dbSelect').val() === 'smfarchdb') {
    				    derbyOptionField.addClass('no-derby')
    				} else {
                        derbyOptionField.removeClass('no-derby');
    				}   
    				
    				$self.initControls();
    				$self.showControls();
    				
    				var dbmsType = data[dbmsType_property]; 
    				
    	            if (dbmsType === null || typeof dbmsType === 'undefined' || dbmsType.trim().length === 0) {
                        $self.setDefaults(db2zos);
    	            }
    	            
    	            $self.options.clearStatus();
    			}
	    	);
			
		},
		
		// User changed the security mode
		securityChanged: function(event, typeChanged) {
		    var securityValue = $('#db2Security').val();
		    var $userIdField = $('#userId');
		    var $passwordField = $('#password');
		    
			if (securityValue === 'idonly') {
				$('.IdPwRow').show();
			    $userIdField.removeAttr('disabled');
				$passwordField.attr('disabled', true);
	            $passwordField.removeClass('error');
	            $passwordField.removeClass('errorborder');
	        	$('.passTicketRow').hide();
	            $.clearStatus();
			} else if (securityValue === 'passTicket_Custom'){
				$('.IdPwRow').hide();
				$('.passTicketRow').show();
				$.clearStatus();
			} else {
			    $userIdField.removeAttr('disabled');
				$passwordField.removeAttr('disabled');
				$('.IdPwRow').show();
				$('.passTicketRow').hide();
			}
			
            if (!typeChanged) {
                var validator = $('#dbConfigForm').validate();
                
                if (!$passwordField.attr('disabled')) {
                    validator.element('#userId');           
                    validator.element('#password');
                }
                
                var adminUserId = $('#dbAdminUserId').val();
                
                if (!!adminUserId && adminUserId.trim().length > 0) {
                    validator.element('#dbAdminPassword');
                }
            }
		},
		
		// User changed the type dropdown
		typeChanged: function() {
			// reset security fields
			$('.access').removeAttr('disabled');
			if(isWindows) {
				$('#useWindowsAuthToggle').prop('checked', false);
			}
			
			// Show/hide controls appropriately
			this.showControls();
			
			// Init fields - If switching back to current type,
			// display current configuration
			var type = $('#dbmsType').val();
			
			if (this.options.dbParameters[dbmsType_property] === type) {
			    this.initControls();
	            $('#import').removeAttr('disabled');
			} else {
				// Set defaults for dbms type selected
			    this.setDefaults(type);
	            $('#import').attr('disabled', true);
			}

            if ($('#dbmsType').val() === "ibmDB2zOS") {
                this.securityChanged(null, true);
            } else if ($('#dbmsType').val() !== "msSQLServer" || (isWindows && !$('#useWindowsAuthToggle').is(':checked'))) {
                $('#password').removeAttr('disabled');
            }
            
			$('#dbConfigForm').validate().resetForm();
			this.options.clearStatus();
		},

		// Set default values based on DBMS type
		setDefaults: function(type) {
			// Clear all fields
			$('#dbConfigForm input').val('');
			
			switch (type) {
    			case db2luw:
    				$('#dbmsPort').val('50000');
    				break;
    				
    			case db2zos:
    			    $('#dbmsPort').val('');
    			    break;
    			    
    			case oracle:
    				$('#dbmsPort').val('1521');
    				break;
    				
    			case sqlserver:
    				$('#dbmsPort').val('1433');
    				if (isWindows) {
    					$('#userWindowsAuth').prop('checked', false);
    				}
    				break;
    
            case derby:
                    $('#dbmsServer').val(window.location.hostname);
                    $('#dbmsPort').val(derbyPort || '1527');
                    $('#dbName').val('CES');
                    $('#schemaName').val('ces');
                    break;
    
    			default:
    				break;
			}
		},
		
		// Show/hide various fields based on DB selected
		showControls: function() {
		    $('#dbConfigForm .error').removeClass('error');
		    $('#dbConfigForm .errorborder').removeClass('errorborder');
		    $('.hidableRow').hide();
		    var nonDerbyFields = $('.non-derby');
		    nonDerbyFields.show();
		    var lockedDerbyFields = $('.derby-locked');
		    lockedDerbyFields.removeAttr('disabled');
		    
        	switch ($('#dbmsType').val()) {
            	case db2luw:
            	    $('.luwRow').show();
            		break;
            		
            	case db2zos:
            	    $('.zosRow').show();
            	    $('#tableSpace').hide();
            	    $('#tableSpaceLabel').hide();
            		$('.passTicketRow').hide();// initially
            		
            		var securityValue = $('#db2Security').val();
            		if (securityValue === 'passTicket_Custom'){
            			$('#userId').hide();
						$('#userIdLabel').hide();
						$('#password').hide();
						$('#passwordLabel').hide();
						$('.passTicketRow').show();
            		}

            		break;
            		
            	case sqlserver:
            	    $('.sqlRow').show();
            		break;
            		
            	case oracle:
            	    $('.oracleRow').show();
            		break;
            		
            	case derby:
            	    $('.non-derby').hide();
            	    lockedDerbyFields.attr('disabled', 'disabled');
            	    break;
            	    
            	default:
            		break;
        	}
		},
		
		initSecurityMode : function(data, securityMode, elementID) {
            if (!!data[securityMode]) {
                var matchFound = false;
                var securityValue = data[securityMode];
                if (securityValue == "off"){securityValue = "none"}
                var securityOptions = $(elementID + ' option');
            
                for (var index = 0; index < securityOptions.length; index++) {
                    var securityOption = $(securityOptions[index]).val();
                    
                    if (securityOption === securityValue) {
                        matchFound = true;
                        break;
                    }
                }
                
                if (matchFound) {
                    $(elementID).val(securityValue);
                    this.securityChanged(null, true);
                }
            }
		},
		
		// Initialize the values of the various input fields
		initControls : function() {
			var data = this.options.dbParameters;
			
			if (!!data[dbmsType_property]) 
				$('#dbmsType').val(data[dbmsType_property]);
			else {
				$('#dbmsType').val(db2zos);
			}
			this.showControls();
			$('#dbmsServer').val(data[dbmsHost_property]);
			
			$('#instanceName').val(data[dbmsInstance_property]);
			
			if(data[dbmsPort_property] == 0 || (data[dbmsInstance_property] != null && !!data[dbmsInstance_property])) {
				$('#dbmsPort').val("");
			} else {
		    	$('#dbmsPort').val(data[dbmsPort_property]);
		    }
			
			$('#db2location').val(data[db2Location_property]);
			
			var dbName = data[dbName_property];
			var tblSpace = '';
			
			if (!dbName) {
			    dbName = '';
			}

			var indx = dbName.indexOf('.');
		
			if (indx !== -1 && $('#dbmsType').val() === "ibmDB2zOS") {
				tblSpace = dbName.substr(indx+1)
				dbName = dbName.substring(0, indx);
			} else {
				tblSpace = 	data[db2zosTablespace_property];
			}
			
			$('#dbName').val(dbName);
			$('#tableSpace').val(tblSpace);
			$('#schemaName').val(data[dbSchema_property]);
			$('#userId').val(data[dbUser_property]);
			
			if (!!data.db2Stogroup_property) {
				$('#stoGroup').val(data.db2Stogroup_property);
			}
			
			if (!!data.db2BufferPool4k_property) {
				$('#bufferpool4k').val(data.db2BufferPool4k_property);
			}
			
			if (!!data.db2BufferPool8k_property) {
				$('#bufferpool8k').val(data.db2BufferPool8k_property);
			}
			
			if (!!data.db2BufferPool16k_property) {
				$('#bufferpool16k').val(data.db2BufferPool16k_property);
			}
			
			if (!!data.db2BufferPool32k_property) {
				$('#bufferpool32k').val(data.db2BufferPool32k_property);
			}
			
			if ($('#dbmsType').val() === "ibmDB2zOS") {
			    $('#sqlId').val(data[db2_sqlid_property]);
			    document.getElementById('sqlIdDML').checked = (data[db2_use_sqlid] === 'true');

				if(!!data[sslConnect_property]) {
					document.getElementById('sslConnect').checked = (data[sslConnect_property] === 'true');
				}
				
				$('#sslKeystore').val(data[sslKeystore_property]);

				$('#sslPassword').val("");
				
				if(!!data[securityMode_property] &&  data[securityMode_property]==='passTicket_Custom') {
					 $('#passticketClass').val(data[passticketClass_property]);
					 $('#passticketBundle').val(data[passticketBundle_property]) ;
				}
				
			}
			
			$('#dbAdminUserId').val(data[dbAdmin_property]);
			
			$('#jdbcDriverLoc').val(data[jdbcDriverPath_property]);
			
			$('#password').val("");
			
			$('#dbAdminPassword').val("");
			
			this.initSecurityMode(data, securityMode_property, '#db2Security');
			this.initSecurityMode(data, sqlSecurityMode_property, '#sqlSecurity');
			
			var notificationEmailData = '';
			
			if (!!data[notification_email_property]) {
				notificationEmailData = data[notification_email_property];
			}
			
			$('#notificationEmail').val(notificationEmailData);
			
			// This has to be done after initSecurityMode because it enables 
			// the userId and password fields.
			this.updateWindowsAuthFieldState(!!data['dbCreate.sql.use.windows.auth'] && data['dbCreate.sql.use.windows.auth'] === 'true');
		},
		
		reset: function() {
		    this.options.clearStatus();
		    this.enableAllFields();
		    this.initControls();
            $('#dbConfigForm .error').removeClass('error');
            $('#dbConfigForm .errorborder').removeClass('errorborder');
	        
			if (!!this.options.resetHandler) {
			    this.options.resetHandler();
			}
		},

		dataChanged: function() {
			var changed = false;
			var data = this.options.dbParameters;
			var dbName = '';
			var tblSpace = !!data[db2zosTablespace_property] ? data[db2zosTablespace_property] : '';
			var driverLoc = !!data[jdbcDriverPath_property] ? data[jdbcDriverPath_property] : '';
			var instanceName = !!data[dbmsInstance_property] ? data[dbmsInstance_property] : '';
			var authId = !!data[db2_sqlid_property] ? data[db2_sqlid_property] : '';
			var sslPw = '';
			var sslKeystore = !!data[sslKeystore_property] ? data[sslKeystore_property] : '';
			var sslConnect = $('#sslConnect').val();
			var sqlSecurityMode = !!data[sqlSecurityMode_property] ? data[sqlSecurityMode_property] : '';
			// The UI uses 'none', but the backend 'off' for the same security mode. This is a workaround.
			sqlSecurityMode  =  sqlSecurityMode === 'off' ? 'none' : sqlSecurityMode; 
			
			if (!!data[dbName_property]) {
				dbName = data[dbName_property];
				var indx = (!!dbName) ? dbName.indexOf('.') : -1;

				if (indx !== -1) {
					tblSpace = dbName.substr(indx+1);
					dbName = dbName.substring(0, indx);
				}
			}

			if (!!data.ssla && !!data.sslb) {
				sslPw = Crypto.decrypt(data.ssla, data.sslb);
			}
			
			if (!!data.sslConnect_property) {
				sslConnect = data.sslConnect_property;
			}
			
			if (($('#dbmsType').val() !== data[dbmsType_property]) ||
					($('#dbmsServer').val() !== data[dbmsHost_property]) ||
					($('#dbmsPort').val() !== data[dbmsPort_property]) ||
					($('#dbName').val() !== dbName) ||
					($('#tableSpace').val() !== tblSpace) ||
					($('#schemaName').val() !== data[dbSchema_property]) ||
					($('#instanceName').val() !== instanceName) ||
					($('#jdbcDriverLoc').val() !== driverLoc) ||
					(!!data[db2_sqlid_property] && $('#sqlid').val() !== data[db2_sqlid_property]) ||
                    (!!data[sqlSecurityMode_property] && $('#sqlSecurity').val() !== sqlSecurityMode) ||
					($('#sslConnect').val() !== sslConnect) ||
					($('#sslKeystore').val() !== sslKeystore) ||
					($('#sslPassword').val() !== sslPw)) {
				changed = true;
			}
			
			return changed;
		},

		// Warning - This routine returns false if non-credential
		// data changed, or if no data changed
		credentialsChanged: function() {
			var credentialsChanged = false;
			var data = this.options.dbParameters;
			var useWindowsAuth = !!data['dbCreate.sql.use.windows.auth'] ? data['dbCreate.sql.use.windows.auth'] === 'true' : false;
			var pw = '';
			if (!!data.a && !!data.b) {
				pw = Crypto.decrypt(data.a, data.b);
			}
			
			var adminPassword = '';
			if (!!data.c && !!data.d) {
			    adminPassword = Crypto.decrypt(data.c, data.d);
			}
			
			if (($('#userId').val() !== data[dbUser_property]) 
					|| ($('#password').val() !== pw) 
					|| (!!data[dbAdmin_property] && ($('#dbAdminUserId').val() !== data[dbAdmin_property]))
					|| ($('#useWindowsAuthToggle').is(':checked') !== useWindowsAuth)
					|| (!!data[securityMode_property] && ($('#db2Security').val() !== data[securityMode_property]))
					|| ($('#dbAdminPassword').val() !== adminPassword)) {
				credentialsChanged = true;
			}
			
			return credentialsChanged;
		},
		
		// Submit the current data for a connection test
		testAndApply: function() {
		    this.options.clearStatus();
			
			if ($('#dbConfigForm').valid()) {
	            if (!!this.options.testAndApplyHandler) {
	                var params = this.getParameters();
	                this.options.testAndApplyHandler(params);
	            }
			}
		},

		saveDDLScripts: function() {
		    this.options.clearStatus();
            var params = this.getParameters();
            this.options.saveDDLScriptsHandler(params);
		},
		
		getParameters: function() {
			var params = {
				dbExists: this.dbExists,
				dbmsType: $('#dbmsType').val(),
				databaseHost: $('#dbmsServer').val(),
				databasePort: $('#dbmsPort').val(),
				databaseDbaName: $('#userId').val(),
				databaseDbaPassword: $('#password').val(),
				databaseAdminUser: $('#dbAdminUserId').val(),
				databaseAdminPassword: $('#dbAdminPassword').val(),
				dbSelect: $('#dbSelect').val(),
				databaseStoGroup: $('#stoGroup').val(),
				bufferpool4k: $('#bufferpool4k').val(),
				bufferpool8k: $('#bufferpool8k').val(),
				bufferpool16k: $('#bufferpool16k').val(),
				bufferpool32k: $('#bufferpool32k').val(),
				notificationEmail: $('#notificationEmail').val()
			};
			
			// if there are single-quotes  surrounding the passphrase, strip themm
			var result = /'(.*)'/.exec(params.databaseDbaPassword);
			if (!!result){
				params.databaseDbaPassword = result[1];
			}
			
			if (params.dbmsType === db2zos) {
				params.databaseName = $('#dbName').val().toUpperCase();
				params.databaseLocation = $('#db2location').val().toUpperCase();
				params.databaseSchema = $('#schemaName').val().toUpperCase();
				
				params.jdbcDriverPath = $('#jdbcDriverLoc').val();
				params.db2Security = $('#db2Security').val();
				
				if($('#db2Security').val() === 'passTicket_Custom') {
					 params.passticketClass = $('#passticketClass').val();
					 params.passticketBundle = $('#passticketBundle').val();
				}
				params.sqlid = $('#sqlId').val();
				params.alwaysUseSqlid = $('#sqlIdDML').is(':checked');
				params.sslConnect = $('#sslConnect').is(':checked');
				params.sslKeystore = $('#sslKeystore').val();
				params.sslKeystorePassword = $('#sslPassword').val();
			} else {
				params.databaseName = $('#dbName').val();
				params.databaseSchema = $('#schemaName').val();
			}

			if (params.dbmsType === db2luw) {
				params.databaseTablespace = $('#tableSpace').val();
				params.jdbcDriverPath = $('#jdbcDriverLoc').val();
			}
			
			if (params.dbmsType === sqlserver) {
				params.instanceName = $('#instanceName').val();
				params.sqlSecurity = $('#sqlSecurity').val();
				params.useWindowsAuth = $('#useWindowsAuthToggle').is(':checked');
			}
			
			return params;
		},

		getTestParams: function(testType) {
			var params = this.getParameters();
			delete params.dbExists;
			params.testType = testType;
			return params;
		},
		
		updateWindowsAuthFieldState : function(useWindowsAuth) {
			if (isWindows) {
				// useWindowAuth is used to force the state by passing in a configuration from the back-end
				if (!!useWindowsAuth || $('#useWindowsAuthToggle').prop('checked')) {
					$('#useWindowsAuthToggle').prop('checked', true);
					$('.access').prop('disabled', 'disabled');
				} else {
					$('#useWindowsAuthToggle').prop('checked', false);
					$('.access').removeAttr('disabled');
				}
			}
		},
		
		disableAllFields: function() {
			$('.form-contents input').attr('disabled', 'disabled');
			$('.form-contents select').attr('disabled', 'disabled');
		},
        
        enableAllFields: function() {
            $('.form-contents input').removeAttr('disabled');
            $('.form-contents select').removeAttr('disabled');
            this.updateWindowsAuthFieldState();
            this.showControls();
        },
	};
	
	$.fn.databaseConfig = function(options) {
		if (!!options) {
            var dbConfig = Object.create(DatabaseConfig);
            dbConfig.init(options, this);
            $.data(this, 'databaseConfig', dbConfig);
            return dbConfig;
		} else {
			return $.data(this, 'databaseConfig');
		}
	};
	
	$.fn.databaseConfig.options = {
	    saveDDLScriptsHandler : null,
	    testAndApplyHandler : null,
		resetHandler : null,
		dbParameters: {},
		dbSelect: 'proddb',
		clearStatus: function() { $.clearStatus(); },
		showError: function(message) { $.showErrorStatus(message); }
	};
	
} ) (jQuery);